// Generated by scripts/build-ui-icons.mjs.
export { MagicWand as default } from "../ui/glyphs-5";
